import { Frame } from '@shared/Frame';
import { Markup } from '@shared/markdown/Markup';
import { ScheduledScreen } from '@shared/types';
import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'markdown-screen',
  styleUrl: 'markdown-screen.scss'
})
export class MarkdownScreen {

  @Prop() screen: ScheduledScreen;

  render() {
    return (
      <Frame>
        <Markup class="markdown col spacing--m text--left">
          {this.screen.data}
        </Markup>
      </Frame>
    );
  }

}
